// i18n
import 'src/locales/i18n';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------
import React, { useEffect } from 'react';
// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// redux
import ReduxProvider from 'src/redux/redux-provider';
// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import MotionLazy from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
import { VersionWatcherNode } from 'src/hooks/use-version-watcher';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/auth0';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/amplify';
// import { AuthProvider, AuthConsumer } from 'src/auth/context/firebase';

// ----------------------------------------------------------------------

export default function App() {

  useScrollToTop();

  // Version watcher must be inside SnackbarProvider to use notistack

    // useEffect(() => {
    //     const head = document.head;
    //     const tidioscriptdemo = document.createElement("script");
    //     tidioscriptdemo.src = "//code.tidio.co/f5nkxd5ibfsaqiva8ycwxpjpwfqibcjc.js";
    //     tidioscriptdemo.async = true;
    //     head.appendChild(tidioscriptdemo);
    // }, []);

    useEffect(() => {
        // Create a meta tag element
        const metaTag = document.createElement('meta');
        metaTag.name = "viewport";
        metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";

        // Append the meta tag to the head
        document.head.appendChild(metaTag);

        const tidioscriptdemo = document.createElement("script");
        tidioscriptdemo.src = "//code.tidio.co/f5nkxd5ibfsaqiva8ycwxpjpwfqibcjc.js";
        tidioscriptdemo.async = true;
        document.head.appendChild(tidioscriptdemo);

        const googleMetaTag = document.createElement('meta');
        googleMetaTag.name = "google";
        googleMetaTag.content = "notranslate";
        document.head.appendChild(googleMetaTag);


        // Cleanup function to remove the meta tag when the component unmounts
        return () => {
            document.head.removeChild(metaTag);
            document.head.removeChild(tidioscriptdemo);
            document.head.removeChild(googleMetaTag);

        };

        // add <meta name="google" content="notranslate">


    }, []);


    return (
        <AuthProvider>
      <ReduxProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'light', // 'light' | 'dark'
              themeDirection: 'ltr', //  'rtl' | 'ltr'
              themeContrast: 'default', // 'default' | 'bold'
              themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
              themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
              themeStretch: false,
            }}
          >
            <ThemeProvider>
              <MotionLazy>
                <SnackbarProvider>
                  <VersionWatcherNode intervalMs={60000} />
                  <SettingsDrawer />
                  <ProgressBar />
                  <AuthConsumer>
                    <Router />
                  </AuthConsumer>
                </SnackbarProvider>
              </MotionLazy>
            </ThemeProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </ReduxProvider>
    </AuthProvider>
  );
}
